import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const NoResultsIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill="none"
      onClick={onClick}
      data-testid="no-results-icon"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill || '#D45B43'}
        fillRule="evenodd"
        d="M16.319 14.908A8.001 8.001 0 004.343 4.343 8 8 0 0014.908 16.32l.042.045 4.242 4.243a1 1 0 001.415-1.415l-4.243-4.242a1.046 1.046 0 00-.045-.042zm-2.076-9.15a6 6 0 11-8.485 8.485 6 6 0 018.485-8.486z"
        clipRule="evenodd"
      />
      <path
        fill={fill || '#D45B43'}
        fillRule="evenodd"
        d="M7.879 6.464L6.465 7.88 8.585 10l-2.12 2.121 1.414 1.415L10 11.414l2.121 2.122 1.415-1.415L11.414 10l2.122-2.121-1.415-1.415-2.12 2.122-2.122-2.122z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default NoResultsIcon;
